function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import { Emoji } from './Emoji/Emoji';
import { ToastChevronRightIcon, ToastDeleteIcon } from './Icons';
import { HorizontalSpace, InlineLink, ToastStringChildren } from './Toast.style';

var useToast = _ref => {
  var {
    link,
    children,
    emoji,
    variant,
    closeable,
    onClose
  } = _ref;

  var renderEmoji = () => !!emoji && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Emoji, {
    symbol: emoji.symbol,
    label: emoji.label
  }), /*#__PURE__*/React.createElement(HorizontalSpace, null));

  var renderChevronRight = () => link && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HorizontalSpace, null), /*#__PURE__*/React.createElement(ToastChevronRightIcon, {
    variant: variant
  }));

  var renderCloseButton = () => closeable && onClose && !link && /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(HorizontalSpace, null), /*#__PURE__*/React.createElement(ToastDeleteIcon, {
    onClick: onClose,
    variant: variant
  }));

  if (typeof children !== 'string') {
    throw new Error('Toast children must be a string');
  }

  var childElement = /*#__PURE__*/React.createElement(ToastStringChildren, {
    variant: variant
  }, children, ' ', link && /*#__PURE__*/React.createElement(InlineLink, _extends({
    variant: variant
  }, link), link.text));
  return {
    text: childElement,
    renderEmoji,
    renderChevronRight,
    renderCloseButton
  };
};

export { useToast };
//# sourceMappingURL=useToast.js.map